// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","279":"component---src-pages-index-jsx"}[chunkId] + "-" + {"125":"cad0728d1628616e1339","279":"193b5a1dd4b2cb08f82f"}[chunkId] + ".js";
};